var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"media"},[_c('AssetEditor',{staticClass:"Editor",attrs:{"entryId":_vm.$route.params.id},on:{"close":function($event){return _vm.$router.push(_vm.base + '/assets')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }